interface DismissButtonProps {
  /** Names the thing being closed, not the action. See below. */
  label: string;
  onDismiss: () => void;
}

/**
 * The × on a dismissible banner.
 *
 * <p>{@link DismissButtonProps.label} should name what's being closed — "Dismiss the alert
 * prompt", not "Close". Someone tabbing through with a screen reader meets these out of context,
 * and three buttons all announcing "Close" tell them nothing about which one to press.
 */
export function DismissButton({ label, onDismiss }: DismissButtonProps) {
  return (
    <button type="button" className="dismiss" onClick={onDismiss} aria-label={label}>
      {/* Decoration only: the accessible name lives on the button, so the glyph is hidden rather
          than read out as "multiplication sign". */}
      <span aria-hidden="true">×</span>
    </button>
  );
}
